import { encodeLabel } from '@aytm/app/stats/lib/util/helpers'

// The name is plain registry text, and it ends up in batch texts and table titles that draw as
// markup, so it is encoded here once.
export const getTraitValues = trait => {
  if (!trait) return []

  const source = trait.values || trait.answerVariants

  if (!source) return []

  return source.map(value => {
    const id =
      (Object.hasOwn(value, 'id') && value.id) || (Object.hasOwn(value, 'position') && `a${value.position}`) || value

    const name =
      (Object.hasOwn(value, 'name') && encodeLabel(value.name.en || value.name)) ||
      (Object.hasOwn(value, 'position') && `A${value.position}`) ||
      value

    return { id, name }
  })
}
